/**
 * Shared utilities.
 */

export const hideOnClickOutside = (element, bodyClass, elementClass) => {
	const outsideClickListener = event => {
		if (!element.contains(event.target)) {

			// IF BODY CLASS
			if( bodyClass ){
				if( bodyClass.constructor.name == "Array" ){
					document.body.classList.remove(...bodyClass)
				} else {
					document.body.classList.remove(bodyClass)
				}
			}

			// IF ELEMENT CLASS
			if( elementClass ){
				if( elementClass.constructor.name == "Array" ){
					element.classList.remove(...elementClass)
				} else {
					element.classList.remove(elementClass)
				}
			}

			// REMOVE CLICK LISTENER
			removeClickListener();
		}
	}

	const removeClickListener = () => {
		document.removeEventListener('click', outsideClickListener);
	}

	document.addEventListener('click', outsideClickListener);
}

	
export const lazyLoadImage = (img) => {
	const src = img.getAttribute("data-src");
	const type = img.getAttribute("loading");
	if (type == "lazy") {
		img.classList.add("lazy--loaded");
	}
	if (!src) {
		return;
	}
	var image = new Image();
	image.src = src;
	image.onload = function () {
		img.src = image.src;
		img.classList.add("lazy--loaded");
	};
};

export const lazyBackground = (img) => {
	const src = img.getAttribute("data-background");
	if (!src) {
		return;
	}
	var image = new Image();
	image.src = src;
	image.onload = function () {
		img.style.backgroundImage = 'url("' + image.src + '")';
		img.classList.add("lazy--loaded");
	};
};

// Linear interpolation
export const lerp = (a, b, n) => (1 - n) * a + n * b;

// Gets the mouse position, attach to an event listener...
export const getMousePos = (e) => {
	let posx = 0;
	let posy = 0;
	if (!e) e = window.event;
	if (e.clientX || e.clientY) {
		posx = e.clientX;
		posy = e.clientY;
	}
	return { x: posx, y: posy };
};

// Get sibilings
export const getSiblings = (e) => {
	// for collecting siblings
	let siblings = [];
	// if no parent, return no sibling
	if (!e.parentNode) {
		return siblings;
	}
	// first child of the parent node
	let sibling = e.parentNode.firstChild;
	// collecting siblings
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== e) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling;
	}
	return siblings;
};

export const getDimensions = (el) => {
	return (
		el.classList[0] +
		" dimensions are " +
		"width - " +
		el.offsetWidth +
		" and height - " +
		el.offsetHeight
	);
};